import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentRole: 'getCurrentRole',
    }),
    canWriteContacts() {
      return !['analyzer', 'assistant'].includes(this.currentRole);
    },
  },
};